module.exports = __webpack_public_path__ + "img/alesco.96fba823.jpg";